<template>
  <div class="nonMobileCover">
  </div>
</template>

<script>
export default {
  name: "NonMobile",
};
</script>

<style scoped>
.nonMobileCover {
  background: url("~@/assets/noMobile_opt1.webp") no-repeat fixed center;
  background-size: cover;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>